import { EnvironmentsEnum } from '@multiversx/sdk-dapp/types';
import nftLendingAbi from 'assets/abi/epunks-nft-lending.abi.json';
import nftAmmAbi from 'assets/abi/nft-amm.abi.json';
import jewelLendAbi from 'assets/abi/jewel-lend.abi.json';
import jewelFarmAbi from 'assets/abi/jewel-ashswap-farm.abi.json';
import ashsawpFarmAbi from 'assets/abi/farm.abi.json';
import deadrare_logo from 'assets/img/marketplaces/deadrare_logo.webp';
import frameit_logo from 'assets/img/marketplaces/frameit_logo.svg';
import isengard_logo from 'assets/img/marketplaces/isengard_logo.png';
import xoxno_logo from 'assets/img/marketplaces/xoxno_logo.webp';

// Generate your own WalletConnect 2 ProjectId here: https://cloud.walletconnect.com/app
// export const walletConnectV2ProjectId = '9291145b1abc47b6a444559a36f7b7b4';
export const walletConnectV2ProjectId = 'a5886fd441f934cdc78aefff0aaefcf2';
export const apiTimeout = 10000;
export const transactionSize = 15;

export const dAppName = 'Epunks NFT Lending Liquidity Protocol';

// devnet
export const isDev = false;

export const Environment = isDev ? EnvironmentsEnum.devnet : EnvironmentsEnum.mainnet;

export const TOOLS_API_URL = 'https://tools.multiversx.com';
/**
 * Calls to these domains will use `nativeAuth` Baerer token
 */
export const sampleAuthenticatedDomains = [TOOLS_API_URL];

///////////////////////////////////////////////////////////////////////
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const NFT_LENDING_SC_ADDRESS = isDev ? "erd1qqqqqqqqqqqqqpgqk0f3sw6ssqn6e0f39fyrh75k8fh68mds9ckqpw42d6" : "erd1qqqqqqqqqqqqqpgqhpauarfmx75nf4pwxh2fuy520ym03p8e8jcqt466up";
export const NFT_LENDING_SC_ABI_JSON = nftLendingAbi;

// NFT AMM
export const NFT_AMM_SC_ADDRESS = isDev ? "erd1qqqqqqqqqqqqqpgqt7fw6m60l0h6ssaml0cyxgvajvw56le45zvs3ppl2u" : "erd1qqqqqqqqqqqqqpgq0erzpydzvy5unmj7867vaapddpc870x44qvqe209k4";
export const NFT_AMM_SC_ABI_JSON = nftAmmAbi;

// Farm
export const JEWEL_LEND_V2_SC_ADDRESS = isDev ? 'erd1qqqqqqqqqqqqqpgqy7vyl0f3vyn45yrmqme95d2pu9h084e9dfys0cwdsm' : 'erd1qqqqqqqqqqqqqpgq96n4gxvmw8nxgxud8nv8qmms5namspc5vmusg930sh';
export const JEWEL_LEND_V2_SC_ABI_JSON = jewelLendAbi;

export const JEWEL_ASHSWAP_SC_ADDRESS = isDev ? 'erd1qqqqqqqqqqqqqpgq0pq3sls73u7x0wqhyw3g50tstq05hpvedfysx0l5ay' : 'erd1qqqqqqqqqqqqqpgqlnxy2hmvs8qxr6ezq2wmggn7ev62cjp6vmusvdral4';
export const JEWEL_ASHSWAP_SC_ABI_JSON = jewelFarmAbi;

export const ASHSWAP_FARM_SC_ABI_JSON = ashsawpFarmAbi;

export const ASHSWAP_VOTING_ESCROW_ADDRESS = isDev ? 'erd1qqqqqqqqqqqqqpgqynvujuhqhrn6qxf3cl49dmnpxt8mqqzc2gespkqv78' : 'erd1qqqqqqqqqqqqqpgq58elfqng8edp0z83pywy3825vzhawfqp4fvsaldek8';
export const VEASH_FEE_ADDRESS = isDev ? 'erd1cgd4652hdsstjsm8y6z34h65pt5s5l6j0rlejx0lg4j9nhzj2d2slc8yay' : 'erd1cgd4652hdsstjsm8y6z34h65pt5s5l6j0rlejx0lg4j9nhzj2d2slc8yay';

export const ASHSWAP_API_GRAPHQL_URL = isDev ? 'https://api-v2-devnet.ashswap.io/graphql' : 'https://api-v2.ashswap.io/graphql';
export const AUTO_COMPOUND_CRON_JOB_TIME = 600; // 10 min

// export const USDT_TOKEN_ID = isDev ? 'USDT-188935' : 'USDT-f8c08c';
export const ASH_TOKEN_ID = isDev ? 'ASH-4ce444' : 'ASH-a642d1';

export const MAX_LEVERAGE = 3;
export const SLIPPAGE = 1;

// export const JEWEL_FARM_POOLS: JewelFarmPool[] = [
//   {
//     sc_address: JEWEL_ASHSWAP_SC_ADDRESS,
//     token_ids: [
//       {
//         token_id: USDT_TOKEN_ID,
//         token_decimal: 6,
//         token_image: usdt_logo,
//       },
//       {
//         token_id: ASH_TOKEN_ID,
//         token_decimal: 18,
//         token_image: ash_logo,
//       },
//     ],
//   },
// ];

export const contracts = {
  'Wrap0': {
    address: isDev ? 'erd1qqqqqqqqqqqqqpgqd77fnev2sthnczp2lnfx0y5jdycynjfhzzgq6p3rax' : 'erd1qqqqqqqqqqqqqpgqvc7gdl0p4s97guh498wgz75k8sav6sjfjlwqh679jy'
  },
  'Wrap1': {
    address: isDev ? 'erd1qqqqqqqqqqqqqpgq7ykazrzd905zvnlr88dpfw06677lxe9w0n4suz00uh' : 'erd1qqqqqqqqqqqqqpgqhe8t5jewej70zupmh44jurgn29psua5l2jps3ntjj3'
  },
  'Wrap2': {
    address: isDev ? 'erd1qqqqqqqqqqqqqpgqfj3z3k4vlq7dc2928rxez0uhhlq46s6p4mtqerlxhc' : 'erd1qqqqqqqqqqqqqpgqmuk0q2saj0mgutxm4teywre6dl8wqf58xamqdrukln'
  }
};
export const WEGLD_ID = isDev ? 'WEGLD-d7c6bb' : 'WEGLD-bd4d79';
export const ADMIN_ADDRESS = isDev ? 'erd1sznpu0vk26uesk8aq03nx5t8uxfw3tngajmmy2jsr58xk3j39ckqj7qfyc' : 'erd19d6z7zdw8er0fltacw0v6zwaaf94qmlp3yf0es8aanq35y33hgjq8lg56u';

// Gas Limit
export const LEND_GAS_LIMIT = 10_000_000;
export const BORROW_GAS_LIMIT = 20_000_000;
export const CLAIM_REWARDS_GAS_LIMIT = 10_000_000;
export const DOWNPAYMENT_GAS_LIMIT = 80_000_000;
export const ENTER_FARM_GAS_LIMIT = 400_000_000;

// Dashboard
export const LATEST_LOAN_SHOW_SIZE = 5;
export const TOP_TRADE_COLLECTIONS_COUNT = 12;

///////////////////////////////////////////////////////////////////////
export enum NftMarketplaceEnum {
  XOXNO = 'XOXNO',
  DEADRARE = 'DEADRARE',
  FRAMEIT = 'FRAMEIT',
  ISENGARD = 'ISENGARD',
}

export const nftMarketplaceMetadata = {
  'XOXNO': {
    logo: xoxno_logo,
  },
  'DEADRARE': {
    logo: deadrare_logo,
  },
  'FRAMEIT': {
    logo: frameit_logo,
  },
  'ISENGARD': {
    logo: isengard_logo,
  },
};

export const buyDownPageSize = 8;
